import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../index.css";
import { LanguageInfo } from "src/config/types";
import { useLocation, useNavigate } from "react-router-dom";
interface Props {
  languageSupport: LanguageInfo;
}

function LanguageSwitch(props: Props) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {pathname} = location;
  const { languageSupport } = props;
  const changeLanguageHandler = (language: any) => {
    i18n.changeLanguage(language);
    localStorage.setItem('preferredLanguage', language);
    const toggledPath = language === "en" ? pathname.replace("/es","/en") : pathname.replace("/en","/es")
    navigate(toggledPath)
  };
  return (
    <div className="language-switch-container flex-container-spacing">
      <span>{t(languageSupport.preferred)}</span>
      <Button
        onClick={() => changeLanguageHandler("en")}
        className={i18n.language === "en" ? "active" : ""}
      >
        {t(languageSupport.en)}
      </Button>
      <Button
        onClick={() => changeLanguageHandler("es")}
        className={i18n.language === "es" ? "active" : ""}
      >
        {" "}
        {t(languageSupport.es)}
      </Button>
    </div>
  );
}

export default LanguageSwitch;
